import type { ReactElement } from 'react';
import { ErrorCode } from '@gr/core/errors';
import { PlatformRole } from '@gr/core/accounts/identity/dto';
import { useT } from '../../../../app/di';
import { FormAlert, FormSelectField, FormTextField, useServerForm } from '../../../../ui-kit/form/form';
import type { ServerOutcome } from '../../../../ui-kit/form/server-errors';

export interface NewUserValues {
  login: string;
  displayName: string;
  password: string;
  platformRole: PlatformRole;
}

/** IAM-UC-5: новый пользователь; отправляется кнопкой с form={id} (подвал диалога). */
export function NewUserForm({ id, onSubmit }: { id: string; onSubmit(values: NewUserValues): Promise<ServerOutcome> }): ReactElement {
  const { t } = useT();
  const { form, submit } = useServerForm<NewUserValues>({
    defaultValues: { login: '', displayName: '', password: '', platformRole: PlatformRole.User },
    fields: ['login', 'displayName', 'password', 'platformRole'],
    onSubmit,
  });
  const { control, formState } = form;
  const required = { required: ErrorCode.FieldRequired };
  const disabled = formState.isSubmitting;
  return (
    <form id={id} className="u-stack" onSubmit={submit} noValidate>
      <FormAlert form={form} />
      <FormTextField control={control} name="login" label={t('identity.users.login')} rules={required} required autoComplete="off" disabled={disabled} />
      <FormTextField control={control} name="displayName" label={t('identity.users.displayName')} rules={required} required disabled={disabled} />
      <FormTextField control={control} name="password" label={t('identity.users.password')} type="password" autoComplete="new-password" rules={required} required disabled={disabled} />
      <FormSelectField
        control={control}
        name="platformRole"
        label={t('identity.users.platformRole')}
        options={Object.values(PlatformRole).map((role) => ({ value: role, label: t(`identity.users.roles.${role}`) }))}
        disabled={disabled}
      />
    </form>
  );
}
